export default __webpack_public_path__ + "static/media/JEENEETOpenBook.1b896a1c757fe3c1c74079b94c04b4f6.webp";